"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_use_1 = require("react-use");
const helpers_1 = require("../../lib/helpers");
function useAutoFocus(ref, enabled) {
    react_use_1.useIsomorphicLayoutEffect(() => {
        if (!enabled || helpers_1.isOnMobileDevice())
            return;
        const focuser = setInterval(() => {
            var _a;
            if (!helpers_1.isFocused(ref)) {
                (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
                clearInterval(focuser);
            }
        }, 100);
        return () => clearInterval(focuser);
    }, [enabled, ref]);
    return ref;
}
exports.default = useAutoFocus;
